import script from "./MyFarmPoolsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyFarmPoolsTable.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__